import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/drift/accept/layer.countDrift.accept.mutation.gql"
import type {
  LayerCountDriftAcceptMutation,
  LayerCountDriftAcceptMutationVariables,
} from "@/v2-backoffice-client/layer/drift/accept/__types__/layer.countDrift.accept.mutation"

export function useLayerCountDriftAcceptMutation(
  options?: MutationHookOptions<
    LayerCountDriftAcceptMutation,
    LayerCountDriftAcceptMutationVariables
  >,
) {
  return useMutation<
    LayerCountDriftAcceptMutation,
    LayerCountDriftAcceptMutationVariables
  >(mutation, options)
}
